import { GridApi } from "@ag-grid-community/core";
import { CdkPortalOutletAttachedRef, ComponentPortal } from "@angular/cdk/portal";
import { Component, ComponentRef, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HeaderService } from "src/app/components/header/header.service";
import { GridApiService } from "src/app/data-grid/grid-api.service";
import { MultiPriceyardPanelComponent } from "./multi-priceyard-panel/multi-priceyard-panel.component";
import { MultiShipyardPanelComponent } from "./multi-shipyard-panel/multi-shipyard-panel.component";

@Component({
  selector: "app-multi-sku-tool-panel",
  templateUrl: "./multi-sku-tool-panel.component.html",
  styleUrls: ["./multi-sku-tool-panel.component.scss"],
})
export class MultiSkuToolPanelComponent implements OnDestroy {
  selectedSkus = [];
  private destroy$ = new Subject<void>();
  selectedPortal;
  gridApi: GridApi;
  portals = {
    inventory: new ComponentPortal(MultiShipyardPanelComponent),
    forcasting: new ComponentPortal(MultiShipyardPanelComponent),
    priceyard: new ComponentPortal(MultiPriceyardPanelComponent)
  };
  private rowChanged$:BehaviorSubject<boolean> = new BehaviorSubject(true);
  isWalmartAccount:boolean;

  constructor(
    private router:Router,
    private headerService:HeaderService
    ) {
    this.headerService.accountSelectedType
    .pipe(takeUntil(this.destroy$))
    .subscribe((e) => {
      if (e) {
        this.isWalmartAccount = e[0] ==='Walmart';         
    }
  });
  } 

  agInit(params: any): void {
    this.gridApi = params.api;
  }

  setSidepanelContent() {
    const appName = this.router.url.split("/").filter((e) => e)[0];
    this.selectedPortal = this.portals[appName];
  }

  refresh() {
    this.selectedSkus = this.gridApi.getSelectedRows();
    this.rowChanged$.next(true);
    this.setSidepanelContent();
  }

  attach(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;
    this.rowChanged$
    .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        ref = ref as ComponentRef<any>;
        ref.instance.selectedSkus = this.selectedSkus;
        ref.instance.isWalmartAccount=this.isWalmartAccount;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
